import * as z from 'zod';

import { dependenteSchema } from '../../../Bussiness-steps/data/schema/functionarysSchema';
import { schema } from './';
import { cadastradoSchema } from './functionarysSchema';
import { inicialSchema } from './inicialSchema';

export const billetSchema = z.object({
  payment: z.optional(
    z.object({
      billetDate: z.optional(
        z.string().min(1, { message: 'Campo obrigatório' }),
      ),
      patrocinio: z.optional(z.string()),
      aceite: z.boolean(),
    }),
  ),

  user: z.optional(schema),
  inicial: z.optional(inicialSchema),
  cadastrado: z.optional(cadastradoSchema),
  newDependents: z.optional(z.array(dependenteSchema)),
});

export type BilletSchema = z.infer<typeof billetSchema>;
